import { __awaiter, __generator } from "tslib";
import { getDB } from '@office-start/idb-cache';
import { deleteDB } from 'idb';
import { databaseName, storeName } from './Constants';
var activeCollections = new Map();
export function getSimplePersistence(userId, collectionName, collectionVersion) {
    return __awaiter(this, void 0, void 0, function () {
        var joinedName, activeCollectionPromise, collectionPromise_1, collection, ex_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    joinedName = userId + "." + databaseName + "." + collectionName;
                    activeCollectionPromise = activeCollections.get(joinedName);
                    if (activeCollectionPromise) {
                        return [2 /*return*/, activeCollectionPromise];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 7]);
                    collectionPromise_1 = getDB(joinedName, {
                        upgrade: function (upgradeDb) {
                            try {
                                upgradeDb.deleteObjectStore(storeName);
                            }
                            catch (_a) {
                                /*
                                Do nothing.
                                Deleting an objectStore that doesn't exist will throw an exception.
                                This will happen on the fist-time creation of this collection.
                                */
                            }
                            upgradeDb.createObjectStore(storeName);
                        },
                        blocking: function () {
                            collectionPromise_1.then(function (db) {
                                db.close();
                                activeCollections.delete(joinedName);
                            });
                        },
                        terminated: function () {
                            activeCollections.delete(joinedName);
                        },
                    }, collectionVersion);
                    return [4 /*yield*/, collectionPromise_1];
                case 2:
                    collection = _a.sent();
                    activeCollections.set(joinedName, collectionPromise_1);
                    return [2 /*return*/, collection];
                case 3:
                    ex_1 = _a.sent();
                    if (!(ex_1 instanceof DOMException)) return [3 /*break*/, 5];
                    // Delete the old collection.
                    return [4 /*yield*/, deleteDB(joinedName)];
                case 4:
                    // Delete the old collection.
                    _a.sent();
                    // retry creating the collection.
                    return [2 /*return*/, getSimplePersistence(userId, collectionName, collectionVersion)];
                case 5: throw new Error("Failed to create database with exception: " + ex_1.toString());
                case 6: return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=getSimplePersistence.js.map